import './App.css';
import JungleSafariApp from './components/Home/Home'

function App() {
  return (
    <div className="App">
 <div className="App">
      
      <JungleSafariApp></JungleSafariApp>
    </div>
    </div>
  );
}

export default App;
